<template>
  <el-dialog
    title="亲爱的管理员，你好！"
    :visible.sync="dialogVisible"
    @close="$emit('update:visible',false)"
  >
    <div class="msg_view">
      <div class="msg_info">
        <P>全新加推APP已经上线超过15天了，你还有这2个同事没有下载App体验哦</P>
        <p>短信通知他们下载加推APP吧～</p>
        <div class="msg_notice">
          <p>（同事姓名),(公司名称)管理员邀请你一起使用加推APP</p>
        </div>
        <el-button>一键群发短信</el-button>
      </div>
      <div class="msg_list">
        <div class="list_box">
          <div class="two_side row">
            <div class="left_side" style="display: flex;">
              <div
                class="avtar"
                style=""
              ></div>
              <div class="center_m">
                <p
                  class="name"
                  style="color: rgb(0, 0, 0); font-weight: 600; white-space: nowrap; text-overflow: ellipsis; overflow: hidden; width: 120px;"
                >夜之</p>
                <p
                  class="dep"
                  style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden; width: 120px;"
                >泉州市图彩数码科技有限公司</p>
              </div>
            </div>
            <div class="right_side">
              <span class="status" style="line-height: 36px;">未激活</span>
            </div>
          </div>
          <div class="two_side row">
            <div class="left_side" style="display: flex;">
              <div
                class="avtar"
                style=""
              ></div>
              <div class="center_m">
                <p
                  class="name"
                  style="color: rgb(0, 0, 0); font-weight: 600; white-space: nowrap; text-overflow: ellipsis; overflow: hidden; width: 120px;"
                >小李</p>
                <p
                  class="dep"
                  style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden; width: 120px;"
                >厦门公司</p>
              </div>
            </div>
            <div class="right_side">
              <span class="status" style="line-height: 36px;">未激活</span>
            </div>
          </div>
        </div>
        <ul>
          <li></li>
        </ul>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "msgDialog",
  props: ["visible"],
  watch: {
    visible() {
      this.dialogVisible = this.visible;
    }
  },
  data() {
    return {
      dialogVisible: this.visible
    };
  }
};
</script>

